export const SUCCESSFUL_GET_PAYMENTMETHOD  = "SUCCESSFUL_GET_PAYMENTMETHOD";


// WEBPACK FOOTER //
// ./src/reducers/paymentmethod/actionConst.js